import * as bd from 'react-basic-design';
import { Link } from 'react-router-dom';
import { T } from '../../components/basic/text';
export const NotFound = () => {
    const container_style = { maxWidth: 450 };
    const title_style = { fontSize: 100, fontWeight: 'bold' };
    return (
        <bd.Flex content="center" align="center" vertical className="mt-5 pt-5 px-3 text-center">
            <div style={container_style}>
                <h1 style={title_style}>
                    <span className="text-danger">4</span>
                    <span className="text-warning">0</span>
                    <span className="text-primary">4</span>
                </h1>
                <T as="h2">the-page-you-are-looking-for-does-not-exists</T>
                <T as="p" className="my-4">
                    the-link-you-followed-probably-broken-or-the-page-has-been-removed
                </T>

                <Link to="/home" className="btn btn-contained btn-primary">
                    <T>return-to-home-page</T>
                </Link>
            </div>
        </bd.Flex>
    );
};
